;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    model: {
        event: 'change'
    },
    props: ["options", "value", "url", "prompt", "process-results-fun"],
    data: function data() {
        return {};
    },

    methods: {
        createSelect2: function createSelect2(options) {
            var vm = this;
            var opts = {};

            $(this.$el).select2({ data: options }).val(this.value).trigger('change').on('change', function () {
                vm.$emit('change', $(this).val());
            });
        }
    },
    mounted: function mounted() {
        this.createSelect2(this.options);
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control"},[_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5d44f204", __vue__options__)
  } else {
    hotAPI.reload("data-v-5d44f204", __vue__options__)
  }
})()}